// The direct agent (?agent=) and the whitelabel partner (?wl=) live in the URL, not in localStorage
// (which users may have disabled): every step carries them along and a reload reads them again.
const PERSISTENT_URL_PARAMS = ["agent", "wl"] as const;

export const hashQueryParams = () => {
  const hash = typeof window === "undefined" ? "" : window.location.hash;
  return new URLSearchParams(hash.includes("?") ? hash.split("?")[1] : "");
};

// Only a param of the real page URL (before the hash), e.g. the funnel key k.
export const readPathParam = (name: string): string | null => {
  if (typeof window === "undefined") return null;
  return new URLSearchParams(window.location.search || "").get(name) || null;
};

// A param of the page URL, before or after the hash route.
export const readUrlParam = (name: string): string | null => {
  const fromSearch = typeof window === "undefined" ? null : new URLSearchParams(window.location.search).get(name);
  return fromSearch || hashQueryParams().get(name) || null;
};

// Appends the persistent params of the current URL to a route, so navigating does not drop them.
export const withPersistentParams = (to: string): string => {
  if (to.includes("?")) return to;
  const current = hashQueryParams();
  const params = new URLSearchParams();
  for (const name of PERSISTENT_URL_PARAMS) {
    const value = current.get(name);
    if (value) params.set(name, value);
  }
  const query = params.toString();
  return query ? `${to}?${query}` : to;
};
